(() => {
  if (window.luxurySizePickerInstalled) return;
  window.luxurySizePickerInstalled = true;
  let dialog, state, busy = false, opener;

  function eligibleVariants(data) {
    const sizeIndex = data.optionNames.findIndex(name => /size/i.test(name));
    const variants = data.variants.filter(v => v.options.every((option, index) =>
      index === sizeIndex || option === data.selectedOptions[index]));
    return { sizeIndex, variants };
  }

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'lux-size-dialog';
    dialog.setAttribute('aria-labelledby', 'lux-size-title');
    dialog.innerHTML = `<button type="button" class="lux-size-close" aria-label="Close size selection">×</button>
      <h2 id="lux-size-title"></h2><p class="lux-size-component"></p><p class="lux-size-price"></p>
      <fieldset class="lux-size-options"><legend>Select your size</legend><div class="lux-size-choices"></div></fieldset>
      <p class="lux-size-message" role="status" aria-live="polite"></p>
      <button type="button" class="lux-size-submit" disabled>Add to Cart</button>`;
    document.body.appendChild(dialog);
    dialog.querySelector('.lux-size-close').addEventListener('click', () => { if (!busy) dialog.close(); });
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus(); });
    dialog.querySelector('.lux-size-submit').addEventListener('click', addSelected);
  }

  function show(button) {
    ensureDialog();
    let data;
    try { data = JSON.parse(button.dataset.luxSizePicker); } catch (_) { return; }
    const {sizeIndex, variants} = eligibleVariants(data);
    state = {data, variant: null};
    opener = button;
    dialog.querySelector('h2').textContent = data.title;
    dialog.querySelector('.lux-size-component').textContent = data.selectedOptions.filter((v,i) => i !== sizeIndex && v !== 'Default Title').join(' / ');
    dialog.querySelector('.lux-size-price').textContent = data.price;
    const options = dialog.querySelector('.lux-size-options');
    const choices = dialog.querySelector('.lux-size-choices');
    const submit = dialog.querySelector('.lux-size-submit');
    const message = dialog.querySelector('.lux-size-message');
    choices.replaceChildren();
    options.hidden = sizeIndex < 0;
    submit.disabled = true;
    submit.textContent = 'Add to Cart';
    message.textContent = '';
    if (sizeIndex >= 0) {
      for (const variant of variants) {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'lux-product-size'; input.value = String(variant.id);
        input.disabled = !variant.available;
        const text = document.createElement('span');
        text.textContent = variant.options[sizeIndex] + (variant.available ? '' : ' — Sold out');
        label.append(input, text); choices.appendChild(label);
        input.addEventListener('change', () => {
          state.variant = variant;
          submit.disabled = false;
          dialog.querySelector('.lux-size-price').textContent = variant.money;
          message.textContent = '';
        });
      }
      message.textContent = variants.some(v => v.available) ? 'Please choose a size.' : 'This set is currently sold out.';
    } else {
      state.variant = variants.find(v => v.available) || null;
      submit.disabled = !state.variant;
      message.textContent = state.variant ? 'Add this item to your cart?' : 'This item is currently sold out.';
      if (state.variant) dialog.querySelector('.lux-size-price').textContent = state.variant.money;
    }
    dialog.showModal();
  }

  async function addSelected() {
    if (busy || !state || !state.variant || !state.variant.available) return;
    busy = true;
    const submit = dialog.querySelector('.lux-size-submit');
    const close = dialog.querySelector('.lux-size-close');
    const options = dialog.querySelector('.lux-size-options');
    submit.disabled = true; close.disabled = true; options.disabled = true;
    submit.textContent = 'Adding…'; dialog.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: state.variant.id, quantity: 1}]})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
      window.location.assign(root + 'cart');
    } catch (error) {
      dialog.querySelector('.lux-size-message').textContent = error.message || 'Unable to add this item. Please try again.';
      busy = false; submit.disabled = false; close.disabled = false; options.disabled = false;
      submit.textContent = 'Add to Cart'; dialog.removeAttribute('aria-busy');
    }
  }

  // Capture before card navigation and existing delegated add-to-cart handlers.
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-lux-size-picker]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!busy && !button.disabled) show(button);
  }, true);
})();
